module.exports = __webpack_public_path__ + "img/e-loading-move.503283ba.png";